import axios from "axios";
import Moment from "moment";
import React, { useEffect, useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import search from "../../assets/images/searchIcon.png";
import filter1 from "../../assets/svg/Health Article/filtericon.svg";
import sort1 from "../../assets/svg/Health Article/sortbyicon.svg";
import Breadcrumbs from "../../components/Common/Breadcrumbs/Breadcrumbs";
import AssignedTo from "../../components/Modal/AssignedTo";
import Deletepopup from "../../components/Modal/Deletepopup";
import LeadStatus from "../../components/Modal/LeadStatus";
import PharmacyRatingCount from "../../components/Modal/PharmacyRatingCount";
import SucessModal from "../../components/Modal/SucessModal";
import { useLocation } from "react-router";

const getsrcValue = (value) => {
  if (typeof value === "string" && value.length)
    return process.env.REACT_APP_API_URL + "pharmacy-rating-images/" + value;
  return typeof value === "object" ? URL.createObjectURL(value) : " ";
};

const DoctorListingForm = () => {
  const [pharmacyIDList, setPharmacyIDList] = useState([]);
  const [pages] = useState(0);
  const [current_page] = useState(1);
  const [countModal, setCountModal] = useState({ id: "", status: false });
  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [leadStatusModal, setLeadStatusModal] = useState({
    id: "",
    status: false,
  });
  const location = useLocation();
  const [success, setSuccess] = useState(false);
  const [leadStatussuccess, setLeadStatusSuccess] = useState(false);

  // const navigate = useNavigate();

  const [deleteModal, setDeleteModal] = useState({ id: "", status: false });

  useEffect(() => {
    getPharmacyIDList();
  }, []);

  const getPharmacyIDList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}booking-details/rating-form-list`)
      .then((response) => {
        setPharmacyIDList(response?.data?.rows);
      });
  };

  const handleDelete = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}booking-details/delete/${id}`)
      .then(() => {
        getPharmacyIDList();
        setDeleteModal({ id: "", status: false });
      });
  };

  const handleClose = () => {
    setDeleteModal({ id: "", status: false });
  };

  const successModalClose = () => {
    setSuccess(false);
    setLeadStatusSuccess(false);
    getPharmacyIDList();
  };

  return (
    <>
      <div className="mt-5 p-4 bg-white">
        <Breadcrumbs
          breadcrumbText="RP QR Ratings"
          breadcrumbLink="/rp-qr-ratings/pharmacy-rating"
          nestedText="QR Ratings Submission"
          nestedLink="#"
        />
        <hr />
        <div className="healtharticle-show m-0 ps-4">
          <div>Show</div>
          <div>
            <select className="me-2">
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option value="0">All</option>
            </select>
          </div>
          <div>entries</div>
          <div>
            <div>
              <img src={search} alt="" />
            </div>
            <div>
              <input
                type="text"
                placeholder="Search"
                className="form-control"
              />
            </div>
          </div>
          <div className="sortandfilter-new">
            <div className="sortByPositionNew">
              <div>
                <div>Sort by</div>
                <div>
                  <img src={sort1} alt="" />
                </div>
              </div>
            </div>
            <div className="sortByDepartment">
              <div>
                <div>
                  <div>Filter</div>
                </div>
                <div>
                  <img src={filter1} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white">
          {pharmacyIDList?.length ? (
            <div className="adLandingFormsTable ms-4">
              <table className="text-center">
                <thead>
                  <tr>
                    <td>S.No</td>
                    <td>Time of Registration</td>
                    <td>Date of Registration</td>
                    <td>Name</td>
                    <td>Mobile No</td>
                  </tr>
                </thead>
                <tbody>
                  {pharmacyIDList?.map((el, i) => {
                    return (
                      <tr key={el._id}>
                        <td>{i + 1}</td>
                        <td>{Moment(el.createdAt).format("LT")}</td>
                        <td>{Moment(el.createdAt).format("DD-MM-YYYY")}</td>
                        <td>{el.name}</td>
                        <td>{el.mobile}</td>
                        <td>
                          {el.images && el.images.length ? (
                            <div>
                              {el.images.map((image, index) => (
                                <img
                                  key={index}
                                  src={getsrcValue(image)}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    marginTop: "2%",
                                    marginBottom: "5%",
                                  }}
                                  alt="icon"
                                />
                              ))}
                            </div>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>{el.android_click ? el.android_click : "-"}</td>
                        <td>{el.ios_click ? el.ios_click : "-"}</td>
                        <td>{el.brochure_click ? el.brochure_click : "-"}</td>
                        <td>{el.assigned_to ? el.assigned_to : "-"}</td>
                        <td>{el.lead_status ? el.lead_status : "-"}</td>
                        <td>
                          <span
                            className="pe-1"
                            onClick={() =>
                              setAssignModal({ id: el._id, status: true })
                            }
                          >
                            Assigned
                          </span>
                          <span className="pe-1">
                            <FaAngleDown className="drop-down-arrow" />
                          </span>
                          <span
                            className="pe-1"
                            onClick={() =>
                              setLeadStatusModal({ id: el._id, status: true })
                            }
                          >
                            Lead Status
                          </span>
                          <span className="pe-1">
                            <FaAngleDown className="drop-down-arrow" />
                          </span>
                          <span
                            className="pe-1"
                            onClick={() =>
                              setDeleteModal({ id: el._id, status: true })
                            }
                          >
                            Delete
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="mt-4">No Pharmacy ID Forms are registered </div>
          )}
        </div>
        <div className="col d-flex pagination admin-pagination justify-content-end">
          <input
            type="button"
            className="page-item page-link"
            value="<<"
            // onClick={(e) => setCurrentPage(1)}
            disabled={current_page === 1}
          />
          <input
            type="button"
            className="page-item page-link"
            value="<"
            // onClick={(e) => setCurrentPage(current_page - 1)}
            disabled={current_page === 1}
          />

          {current_page > 1 && (
            <input
              type="button"
              value={current_page - 1}
              onClick={(e) => {
                // setCurrentPage(current_page - 1);
              }}
            />
          )}
          <input
            className="page-item page-link"
            type="button"
            value={current_page}
          />
          {current_page < pages && (
            <input
              type="button"
              value={current_page + 1}
              onClick={(e) => {
                // setCurrentPage(current_page + 1);
              }}
            />
          )}
          <input
            type="button"
            value=">"
            className="page-item page-link"
            // onClick={(e) => setCurrentPage(current_page + 1)}
            disabled={current_page === pages}
          />
          <input
            type="button"
            value=">>"
            className="page-link"
            // onClick={(e) => setCurrentPage(pages)}
            disabled={current_page === pages}
          />
        </div>
      </div>
      {assignModal.status === true && (
        <AssignedTo
          id={assignModal?.id}
          setAssignModal={setAssignModal}
          setSuccess={setSuccess}
        />
      )}
      {leadStatusModal.status === true && (
        <LeadStatus
          id={leadStatusModal?.id}
          setLeadStatusModal={setLeadStatusModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
        />
      )}
      {success && (
        <SucessModal
          name="BD"
          post="Assigned"
          page={location.pathname}
          onClick={() => successModalClose()}
        />
      )}
      {deleteModal.status === true && (
        <Deletepopup
          handleDelete={handleDelete}
          id={deleteModal?.id}
          isCloseModalEnable={true}
          handleClose={handleClose}
        />
      )}
      {countModal.status === true && (
        <PharmacyRatingCount
          id={countModal?.id}
          setCountModal={setCountModal}
        />
      )}
      {leadStatussuccess && (
        <SucessModal
          name="Lead Status"
          post="Updated"
          page={location.pathname}
          onClick={() => successModalClose()}
        />
      )}
    </>
  );
};

export default DoctorListingForm;
